import { SvgIconType } from './svg.interface';

const TruckIcon: SvgIconType = ({
  width = 16,
  height = 16,
  className = '',
  color = '#3AA5DC'
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 3C0 2.73478 0.105357 2.48043 0.292893 2.29289C0.48043 2.10536 0.734784 2 1 2H10.5C10.7652 2 11.0196 2.10536 11.2071 2.29289C11.3946 2.48043 11.5 2.73478 11.5 3V5H13.465C13.6296 4.99998 13.7916 5.04058 13.9368 5.11821C14.0819 5.19583 14.2057 5.30808 14.297 5.445L15.748 7.622C15.9123 7.86838 16 8.15787 16 8.454V11.25C16 11.3826 15.9473 11.5098 15.8536 11.6036C15.7598 11.6973 15.6326 11.75 15.5 11.75H14.5C14.5 12.3467 14.2629 12.919 13.841 13.341C13.419 13.7629 12.8467 14 12.25 14C11.6533 14 11.081 13.7629 10.659 13.341C10.2371 12.919 10 12.3467 10 11.75H6C6 12.3467 5.76295 12.919 5.34099 13.341C4.91903 13.7629 4.34674 14 3.75 14C3.15326 14 2.58097 13.7629 2.15901 13.341C1.73705 12.919 1.5 12.3467 1.5 11.75H1C0.734784 11.75 0.48043 11.6446 0.292893 11.4571C0.105357 11.2696 0 11.0152 0 10.75V3ZM3.75 12.5C3.84849 12.5 3.94602 12.4806 4.03701 12.4429C4.12801 12.4052 4.21069 12.35 4.28033 12.2803C4.34997 12.2107 4.40522 12.128 4.44291 12.037C4.4806 11.946 4.5 11.8485 4.5 11.75C4.5 11.6515 4.4806 11.554 4.44291 11.463C4.40522 11.372 4.34997 11.2893 4.28033 11.2197C4.21069 11.15 4.12801 11.0948 4.03701 11.0571C3.94602 11.0194 3.84849 11 3.75 11C3.55109 11 3.36032 11.079 3.21967 11.2197C3.07902 11.3603 3 11.5511 3 11.75C3 11.9489 3.07902 12.1397 3.21967 12.2803C3.36032 12.421 3.55109 12.5 3.75 12.5ZM13 11.75C13 11.9489 12.921 12.1397 12.7803 12.2803C12.6397 12.421 12.4489 12.5 12.25 12.5C12.0511 12.5 11.8603 12.421 11.7197 12.2803C11.579 12.1397 11.5 11.9489 11.5 11.75C11.5 11.5511 11.579 11.3603 11.7197 11.2197C11.8603 11.079 12.0511 11 12.25 11C12.4489 11 12.6397 11.079 12.7803 11.2197C12.921 11.3603 13 11.5511 13 11.75ZM11.5 8V6H13.667L15 8H11.5Z"
      fill={color}
    />
  </svg>
);

export default TruckIcon;
